import React from 'react'
import infos from './data.json';
import Fade from 'react-reveal/Fade'
import {LineAllContent,LineTitle,LineSbTitleParr,LineContainer,LineContent,LineBox,LineSubtile,LineParra,LineJob,LineLocation,LineDate,LineIcon,LineIcono} from './LineElements'
function Line() {
  return (
      <>
      <LineAllContent>
          <LineTitle>
              Experiencia del Jimmy
          </LineTitle>
          <LineSbTitleParr>
            A continuación podrás saber acerca de mi experiencia laboral, 
            algunos de los nombres de las empresas en las cuales he laborado 
            tienen este símbolo <LineIcono /> lo que significa para mí que fueron las empresas 
            en donde más logre obtener conocimiento o logre dar los resultados esperados de cada proyecto. 
          </LineSbTitleParr>
      </LineAllContent>
        <LineContainer>
            <LineContent>
                {infos.map(info =>{
                    return(
                    <LineBox key={info.id}>
                        <Fade bottom>
                            <LineSubtile>{info.title} <LineIcon strong={info.strong ? 1 : 0} /></LineSubtile>
                            <LineLocation>{info.location}</LineLocation>
                            <LineDate>{info.date}</LineDate>
                            <LineJob>{info.job}</LineJob>
                            <LineParra>{info.description}</LineParra>
                            <LineParra>{info.tecno}</LineParra>
                        </Fade>
                    </LineBox>
                    )
                })} 
            </LineContent>
        </LineContainer>
      </>
  )
}

export default Line